import React from 'react';

export type LinkIconType = 'InternalIcon' | 'ExternalIcon';

interface LinkIconProps {
  type?: LinkIconType | string | null;
  className?: string;
}

const LinkIcon: React.FC<LinkIconProps> = ({ type, className = 'w-5 h-5' }) => {
  if (!type) {
    return null;
  }

  if (type === 'ExternalIcon') {
    return (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
        />
      </svg>
    );
  }

  if (type === 'InternalIcon') {
    return (
      <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M17 8l4 4m0 0l-4 4m4-4H3"
        />
      </svg>
    );
  }

  return null;
};

export default LinkIcon;
